import { z } from 'zod';

// ADR 0004: admins are auth users holding a role in `user_roles`
// (the `admin_users` allowlist table is dropped).
export const adminRoleSchema = z.literal('admin');
export type AdminRole = z.infer<typeof adminRoleSchema>;

export const userRoleSchema = z.object({
  userId: z.string(),
  role: adminRoleSchema,
});
export type UserRole = z.infer<typeof userRoleSchema>;
